import * as React from 'react'
import { styled } from 'next-yak'

import * as S from '../../styles'
import { useTransition } from '../../behaviours'
import { Spinner } from '../Spinner'
import type { PolymorphicComponent, YakComponentOf } from '@owl-nest/yak/extra-runtime'

type ExtraButtonProps = {
  active?: boolean
  disabled?: boolean
  fitToParent?: boolean
  inverted?: boolean
  loading?: boolean
  prefixIcon?: React.ReactNode
  suffixIcon?: React.ReactNode
}

export type RoundButtonProps = ExtraButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>

function RoundButtonComponent({
  active = false,
  children,
  disabled = false,
  fitToParent = false,
  loading = false,
  prefixIcon,
  suffixIcon,
  inverted = false,
  ...buttonProps
}: RoundButtonProps): React.ReactElement<any> {
  const { step, unmounted, onTransitionEnd } = useTransition(loading)

  return (
    <S.button.RoundButton
      $active={active}
      disabled={disabled}
      $fitToParent={fitToParent}
      $inverted={inverted}
      $loading={loading}
      $step={step}
      $unmounted={unmounted}
      {...buttonProps}
    >
      {prefixIcon && prefixIcon}
      <S.button.Label>{children}</S.button.Label>
      <Spinner onTransitionEnd={onTransitionEnd} small />
      {suffixIcon && suffixIcon}
    </S.button.RoundButton>
  )
}

export const RoundButton = styled(RoundButtonComponent)`` as YakComponentOf<
  PolymorphicComponent<'button', ExtraButtonProps>
>
